import Vue from 'vue';
import {request, setAuthInHeader,requestPython} from "@/api/request";


Vue.prototype.$api = {
  $auth: { // 계정 로그인 / 회원가입 api
    login(params){ // 유저 로그인
      return request.post("member/login", params)
        .then(({data}) => data);
    },
    checkUserID(id){ // 유저 아이디 중복 체크
      return request.get("user/id_chk?mb_id=" + id)
        .then(({data}) => data);
    },
  },

  $firebase: {
    dynamicAutoUpload(params){
      return request.post('dynamiclinkBySafetyBell/auto_upload',params)
        .then(({data}) => data);
    },

  },


  $user: { // 유저 정보 관련 api
    getMemberList(params) {
      return request.get("member", params)
        .then(({data}) => data);
    },
    createMember(params) {
      return request.post(`member`, params)
        .then(({data}) => data);
    },
    updateMember(params) {
      return request.post(`member/update`, params)
        .then(({data}) => data);
    },
    getCountry(){
      return request.get("country")
        .then(({data}) => data);
    },
    getLanguage(params) {
      return request.get("language", params)
        .then(({data}) => data);
    },
    getLanguageCountryList(params) {
      return request.get(`language/country`, params)
        .then(({data}) => data);
    }
  },


  $license: {
		getLicenseList(params) {
			return request.get("license",params)
				.then(({data}) => data);
		},
	  createLicense(params) {
		  return request.post(`license`, params).then(({data}) => data);
	  },
	  updateLicense(params) {
		  return request.post(`license/update`, params).then(({data}) => data);
	  },
	  deleteLicense(params) {
		  return request.post(`license/delete`, params).then(({data}) => data);
	  },
  },
  $product: {

    getProductList(params) {
      return request.get("safetyBellByList/license",params)
        .then(({data}) => data);
    },

    getProductMemberList(params) {
      return request.get("safetyBellByList/member",params)
        .then(({data}) => data);
    },
    getLicenceList(params) {
      return request.get("license",params)
        .then(({data}) => data);
    }
  },


  $method: { // 사용법

    getMethod(params) {
      return request.get("video",params)
        .then(({data}) => data);
    },
    setMethod(params) {
      return request.post("video",params)
        .then(({data}) => data);
    },
    updateMethod(params) {
      return request.post("video/update",params)
        .then(({data}) => data);
    },
    deleteMethod(params) {
      return request.post("video/delete",params)
        .then(({data}) => data);
    },
  },

  $board : {
  //안전정보 카테고리
    getSafetyCategory(params) {
      return request.get("board/safety/category",params)
        .then(({data}) => data);
    },
    getSafety(params) {
      return request.get("board/safety",params)
        .then(({data}) => data);
    },
    setSafety(params) {
      return request.post("board/safety",params)
        .then(({data}) => data);
    },
    updateSafety(params) {
      return request.post("board/safety/update",params)
        .then(({data}) => data);
    },
    deleteSafety(params) {
      return request.post("board/safety/delete",params)
        .then(({data}) => data);
    },


    //공지사항
    getNotice(params) {
      return request.get("board/notice",params)
        .then(({data}) => data);
    },
    setNotice(params) {
      return request.post("board/notice",params)
        .then(({data}) => data);
    },
    updateNotice(params) {
      return request.post("board/notice/update",params)
        .then(({data}) => data);
    },
    deleteNotice(params) {
      return request.post("board/notice/delete",params)
        .then(({data}) => data);
    },

    //FAQ
    getFaqCategory(params) {
      return request.get("faq/category",params)
        .then(({data}) => data);
    },
 /*   setFaqCategory(params) {
      return request.post("faq/category", params)
        .then(({data}) => data);
    },*/
    getFaq(params) {
      return request.get("faq",params)
        .then(({data}) => data);
    },
    setFaq(params){
      return request.post("faq",params)
        .then(({data}) => data);
    },
    updateFaq(params) {
      return request.post("faq/update",params)
        .then(({data}) => data);
    },
    deleteFaq(params) {
      return request.post("faq/delete",params)
        .then(({data}) => data);
    },

    getQaList(params) {
      return request.get("qa",params)
        .then(({data}) => data);
    },
    setQaAnswer(params) {
      return request.post("qa/answer",params)
        .then(({data}) => data);
    },
    updateQa(params) {
      return request.post("qa/answer/update",params)
        .then(({data}) => data);
    },
    deleteQa(params) {
      return request.post("qa/delete",params)
        .then(({data}) => data);
    },
  },


  $config: {
    //약관 정보 관련 api
    getConfig(params) {
      return request.get("config",params)
        .then(({data}) => data);
    },
    createConfig(params) {
      return request.post("config",params)
        .then(({data}) => data);
    },
    updateConfig(params) {
      return request.post("config/update",params)
        .then(({data}) => data);
    },
    deleteConfig(params) {
      return request.post("config/delete",params)
        .then(({data}) => data);
    }
  },



  $popup: {
    getPopupList(params) {
      return request.get(`popup`,params)
        .then(({data}) => data);
    },
    createPopup(params) {
      return request.post(`popup`, params)
        .then(({data}) => data);
    },
    updatePopup(params) {
      return request.post(`popup/update`, params)
        .then(({data}) => data);
    },
    deletePopup(params) {
      return request.post(`popup/delete`, params)
        .then(({data}) => data);
    }
  },



  $file: {
    //파일
    updateFile(params) {
      return request.post("files",params)
        .then(({data}) => data);
    },
    deleteFile(params) {
      return request.post("files/delete/"+params.a_idx)
        .then(({data}) => data);
    },

    editorUpload(params) {
      return request.post("files/editorUpload",params)
        .then(({data}) => data);
    },

  },

  $dash : {
    getMemberList(params) {
      return request.get(`dashboard/member`,params)
        .then(({data}) => data);
    },
    getMemberPeriodList(params) {
      return request.get(`dashboard/period`,params)
        .then(({data}) => data);
    },
    getLicenseList(params) {
      return request.get(`dashboard/license`,params)
        .then(({data}) => data);
    },
    getProductList(params) {
      return request.get(`dashboard/safetybell`,params)
        .then(({data}) => data);
    },
    getLicenseProductList(params) {
      return request.get(`dashboard/license/safetybell`,params)
        .then(({data}) => data);
    },
    getLicenseGenuineList(params) {
      return request.get(`dashboard/member/license`,params)
        .then(({data}) => data);
    },
    getProductGenuineList(params) {
      return request.get(`dashboard/member/safetybell`,params)
        .then(({data}) => data);
    },
    getLicenseProductGenuineList(params) {
      return request.get(`dashboard/member/license/safetybell`,params)
        .then(({data}) => data);
    },
  },
  $alert : {
    getAlert(params) {
      return request.get(`nfc`,params)
        .then(({data}) => data);
    },
    deleteAlert(params) {
		  return request.post(`nfc/delete`, params).then(({data}) => data);
	  },
    checkExiseAlert(params){
      return request.get(`nfc/chk`,params)
        .then(({data}) => data);
    }
  },
  /*
  $examples : {
    getExample() {
      return request.get("examples")
        .then(({data}) => data);
    },
    createExample(params) {
      return request.post("examples",params)
        .then(({data}) => data);
    },
    updateExample(params) {
      return request.post("examples/update",params)
        .then(({data}) => data);
    },
    deleteExample(params) {
      return request.post("examples/delete",params)
        .then(({data}) => data);
    },

  },*/
  $nfc:{
    getDashBoard(params) {
      return request.get(`dashboard/nfc`,params)
          .then(({data}) => data);
    },
    getDashBoardNfcHistory(params) {
      return request.get(`nfc`,params)
          .then(({data}) => data);
    },
    getNfcServerKey(params){
      return request.post("nfc/start",params)
      .then(({data}) => data);
    },    
    getNfcServerStatus(params){
      return requestPython.get("status",params)
      .then(({data}) => data);
    },
    startNfcServer(params){
      return requestPython.get("start",params)
      .then(({data}) => data);
    },
    stopNfcServer(params){
      return requestPython.get("stop",params)
      .then(({data}) => data);
    }
  },

  $handler: {
    authHeader : setAuthInHeader
  }
};

export default Vue.prototype.$api;
